import Route from '@ember/routing/route';

export default class FourOhFour extends Route {
  // normal class body definition here
}
